// extracted by mini-css-extract-plugin
module.exports = {"mobile-menu-container":"ArtworksPage_mobile-menu-container__PIHn3","filter-mobile":"ArtworksPage_filter-mobile__c60J7"};